import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiGrid, FiFolder, FiCheckSquare, FiList, FiFileText, FiSend, FiUsers, FiMenu, FiX, FiClock, FiBarChart2, FiDollarSign, FiLayers } from 'react-icons/fi';
import './Sidebar.css';

const Sidebar = ({ user, workspace, collapsed, onToggle, isMobile, mobileOpen, onMobileClose }) => {
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: <FiGrid /> },
    { path: '/boards', label: 'Boards', icon: <FiFolder /> },
    { path: '/portfolio-gantt', label: 'Portfolio Gantt', icon: <FiBarChart2 /> },
    { path: '/finance-projects', label: 'Quotations & Costing', icon: <FiDollarSign /> },
    { path: '/my-work', label: 'My Work', icon: <FiCheckSquare /> },
    { path: '/shared-lists', label: 'Shared Lists', icon: <FiLayers /> },
    { path: '/global-tasks', label: 'Global Tasks', icon: <FiList /> },
    { path: '/rfis', label: 'RFIs', icon: <FiFileText /> },
    { path: '/submittals', label: 'Submittals', icon: <FiSend /> },
    { path: '/team-members', label: 'Team Members', icon: <FiUsers /> },
    { path: '/activity-log', label: 'Activity Log', icon: <FiClock /> },
  ];

  const companyName = workspace?.name || 'AA Architecture';

  // On mobile we always show full labels (not collapsed) when drawer open
  const effectiveCollapsed = isMobile ? false : collapsed;

  const classes = [
    'sidebar',
    effectiveCollapsed ? 'collapsed' : '',
    isMobile ? 'mobile' : '',
    isMobile && mobileOpen ? 'mobile-open' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} data-testid="main-sidebar">
      <div className="sidebar-header" data-testid="sidebar-header">
        {!effectiveCollapsed && <div className="sidebar-logo" title={companyName}>{companyName}</div>}
        {isMobile ? (
          <button
            className="sidebar-toggle"
            onClick={onMobileClose}
            data-testid="sidebar-mobile-close-button"
            aria-label="Close menu"
          >
            <FiX size={22} />
          </button>
        ) : (
          <button
            className="sidebar-toggle"
            onClick={onToggle}
            data-testid="sidebar-toggle-button"
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? <FiMenu size={20} /> : <FiX size={20} />}
          </button>
        )}
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`sidebar-nav-item ${location.pathname === item.path ? 'active' : ''}`}
            data-testid="sidebar-nav-item"
            onClick={() => { if (isMobile && onMobileClose) onMobileClose(); }}
          >
            <span className="sidebar-nav-item-icon">{item.icon}</span>
            {!effectiveCollapsed && <span className="sidebar-nav-item-text">{item.label}</span>}
          </Link>
        ))}
      </nav>
      {!effectiveCollapsed && user && (
        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="avatar avatar-sm">
              {user.name?.charAt(0).toUpperCase() || 'U'}
            </div>
            <div className="sidebar-user-info">
              <div className="sidebar-user-name">{user.name}</div>
              <div className="sidebar-user-role">{user.role}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
